import {Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {RouteId} from 'src/app/enums/env/routes-id-enum';
import {AlarmKey} from 'src/app/enums/search-key.enum';
import {FilterValue} from 'src/app/interfaces/filtres/filter-interface';
import {DateStartEndModel} from 'src/app/tinea-components/dateTime-picker/models/datesStartEndModel';
import {BtnActionEnum} from '../../btn-action/enums/btn-action.enum';
import {BtnActionInterface} from '../../btn-action/interfaces/btnAction.interface';
import {SearchService} from '../../search/services/search.service';

@Component({
    selector: 'app-search-alarm-list',
    templateUrl: './search-alarm-list.component.html',
    styleUrls: ['./search-alarm-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchAlarmListComponent implements OnInit {
  filterList: FilterValue<AlarmKey>[] = [];
  @Input() routeId: RouteId;
  @Input() eUid?: string;
  requestInProce = false;
  filterSearch: FilterValue<AlarmKey>;
  btnActionClick: BtnActionInterface;
  startDateFilter: string;
  endDateFilter: string;
  queryParamSearch: string;
  btnActionEnum  = BtnActionEnum;
  constructor(
    private searchService: SearchService,
    ) {}

  ngOnInit(): void {
    // initialise le tableau pour qu'il puisse les récupérer lors du changement de valeur des autres params
    this.filterList = [
        {value: '', key: AlarmKey.SEARCH},
        {value: '', key: AlarmKey.DATEEND},
        {value: '', key: AlarmKey.DATESTART}
    ];
  }

  getDatesFromFilter(dates: DateStartEndModel) {
    this.searchService.changeDatesFilter(dates, this.filterList, this.routeId);
    this.changeDateValueInFilterList(dates);
  }
  changeDateValueInFilterList(dates: DateStartEndModel) {
    const tab = [...this.filterList];
    tab.find((elm) => elm.key === AlarmKey.DATESTART).value = dates.dateStart;
    tab.find((elm) => elm.key === AlarmKey.DATEEND).value = dates.dateEnd;
    this.filterList = tab;
  }
  ngOnChanges(change: SimpleChanges) {
    if (change.filterList) {
      this.filterSearch = this.filterList.find(
        (elm) => elm.key === AlarmKey.SEARCH
      );
      this.searchService.changeQueryParamsSession<AlarmKey>(
        this.filterList,
        this.routeId,
      );
    }
  }

  btnEventReceiver($event: boolean, typeBtn: string ) {
    // il y a eu un click
    if ($event == true) {
      switch (typeBtn) {
        case 'EXPORT' :
          this.btnActionClick = {
            typeBtn : BtnActionEnum.EXPORT
          };
        break;
        default :
        break;
      }
    }
  }
  eventInProcess($event: any) {
    this.requestInProce = $event;
  }

  updateSearchVal(searchVal: any) {
    const tab = [...this.filterList];
    if (tab.length > 0) {
      tab.find((elm) => elm.key === searchVal.key).value = searchVal.value;
    } else {
      tab.push(searchVal);
    }
    this.filterList = tab;
  }
}
